import React from 'react'
import styled from '@emotion/styled'
import { ssrWarning, pickToCss } from 'utils/emotion'

const flexCss = pickToCss([
  'flexDirection',
  'flexWrap',
  'flexFlow',
  'gap',
  'margin',
  'justifyContent',
  'alignItems',
  'alignContent',
  'width',
])

const flexChildCss = pickToCss([
  'order',
  'flexGrow',
  'flexShrink',
  'flexBasis',
  'flex',
  'alignSelf',
  'justifySelf',
])

const applyFlexStyles = (props) => {
  const { children } = props

  const multiptleChildStyleReducer = (acc, child, index) => {
    if (!child || !child.props) return ''
    const nthChildSelector = `>*:nth-child(${index + 1}) ${ssrWarning}`

    return `
      ${acc}
      ${nthChildSelector} {
        ${flexChildCss(child.props)}
      }
    `
  }

  const childStyles = (childrenArray) => {
    if (!childrenArray.length) {
      return `
        >* {
          ${flexChildCss(childrenArray.props)}
        }
      `
    }

    return childrenArray.reduce(multiptleChildStyleReducer, '')
  }

  return `
    display: flex;
    ${flexCss(props)}
    ${childStyles(children)}
  `
}

const withFlex = (Component) => {
  const StyledFlex = styled(Component)(applyFlexStyles)
  return (props) => <StyledFlex {...props} />
}

export default withFlex

export const Flex = styled.div(applyFlexStyles)
